/* ms-utm-capture.js
   Stamps the originating ad/source onto the Shopify cart so it lands on the order
   as customAttributes (read later by the Growth Machine reader).

   Captures TWO touches so both ROAS cells work:
     - FIRST touch (ms_utm_*): the first tagged visit ever, kept in localStorage.
       Powers Assisted ROAS (the ad introduced them, however they came back to buy).
     - LAST touch (ms_last_utm_*): the most recent tagged visit, overwritten each time.
       Powers Direct ROAS (the click that led to this purchase).

   - Source agnostic: any utm_* (Facebook, Google, TikTok, email), not app-specific.
   - Avada safe: external asset, no inline style or hidden input (golden rule 8).
   - Writes nothing when there is no utm (direct/organic stays unattributed, correct).
*/
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var FIRST = 'ms_attribution_first';
  var LAST = 'ms_attribution_last';
  var PUSHED = 'ms_attribution_pushed';

  function readFromUrl() {
    var q = new URLSearchParams(window.location.search);
    var found = {}, has = false;
    KEYS.forEach(function (k) { var v = q.get(k); if (v) { found[k] = v; has = true; } });
    return has ? found : null;
  }
  function load(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function save(key, d) {
    try { localStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
  }

  var fresh = readFromUrl();
  var first = load(FIRST);
  var last = load(LAST);
  var taggedVisit = !!fresh;

  if (fresh) {
    fresh.seen = new Date().toISOString();
    fresh.landing = window.location.pathname;
    if (!first) { save(FIRST, fresh); first = fresh; }  // first touch: set once
    save(LAST, fresh); last = fresh;                    // last touch: always update
  }

  if (!first && !last) return; // nothing to attribute

  // Push on every tagged visit (to refresh last touch), else once per session.
  var pushedThisSession = false;
  try { pushedThisSession = sessionStorage.getItem(PUSHED) === '1'; } catch (e) {}
  if (!taggedVisit && pushedThisSession) return;

  var attrs = {};
  if (first) Object.keys(first).forEach(function (k) { attrs['ms_' + k] = String(first[k]); });
  if (last) Object.keys(last).forEach(function (k) { attrs['ms_last_' + k] = String(last[k]); });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs })
  }).then(function () {
    try { sessionStorage.setItem(PUSHED, '1'); } catch (e) {}
  }).catch(function () {});
})();

/* Wholesale lead attribution (same concern, module 2).
   The cart-attribute stamp above only fires at purchase; wholesale leads sign up
   on /pages/wholesale-registration (Helium Customer Fields form) and may not buy
   for weeks, on another device, through a SparkLayer cart the stamp never touches.
   So this stamps the stored first/last ad touch onto the lead's Klaviyo profile:
   identify by the email typed into the form + a "Wholesale Lead" event. Analysis
   join: Klaviyo profile (wholesale_* props / event) -> Shopify customer (email,
   b2b tag, lifetime spend) -> Meta ad (utm_id = ad id).

   The Helium form is MULTI STEP: the email field lives on one step and is removed
   from the DOM on later steps, and the step buttons are type=button (no native
   submit event). So the email is remembered the moment it is typed (input/blur,
   document-level capture) and the stamp fires on blur of a valid email and again
   defensively on any form button click / submit. Dedupe: one send per email value.
   A lead who types an email but abandons only creates an orphan Klaviyo profile;
   it never joins a b2b customer, so analysis is unaffected.
   Fire and forget: never blocks, delays, or alters the signup itself. */
(function () {
  if (window.location.pathname.indexOf('wholesale-registration') === -1) return;

  var FIRST = 'ms_attribution_first';
  var LAST = 'ms_attribution_last';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var sentFor = null;
  var rememberedEmail = '';

  function load(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function buildProps() {
    var first = load(FIRST), last = load(LAST), props = {};
    if (first) Object.keys(first).forEach(function (k) { props['first_' + k] = String(first[k]); });
    if (last) Object.keys(last).forEach(function (k) { props['last_' + k] = String(last[k]); });
    return props;
  }

  function kPush(args) {
    // Klaviyo's loader consumes window._klOnsite; a live Klaviyo exposes a proxy
    // object at window.klaviyo. A self-made plain array at window.klaviyo would
    // NEVER be consumed (verified 2026-07-11), so queue via _klOnsite instead.
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function' && !Array.isArray(window.klaviyo)) {
        window.klaviyo.push(args);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(args);
      }
    } catch (e) {}
  }

  function send(email) {
    if (!email || email === sentFor) return;
    sentFor = email;
    var props = buildProps();
    if (!Object.keys(props).length) props.untracked = 'no stored utm (direct/organic signup)';
    props.signup_page = window.location.pathname;
    var idProps = { '$email': email };
    Object.keys(props).forEach(function (k) { idProps['wholesale_' + k] = props[k]; });
    kPush(['identify', idProps]);
    kPush(['track', 'Wholesale Lead', props]);
  }

  function getForm() { return document.querySelector('form[data-cf-form]'); }

  function fillHiddenUtms(form) {
    var src = load(LAST) || load(FIRST);
    if (!src) return;
    UTM_KEYS.forEach(function (k) {
      if (!src[k]) return;
      var el = form.querySelector('input[name*="' + k + '"]');
      if (el && !el.value) el.value = String(src[k]);
    });
  }

  function isEmailInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (el.type === 'email') return true;
    return !!(el.name && el.name.toLowerCase().indexOf('email') !== -1);
  }

  function validEmail(v) {
    v = (v || '').trim().toLowerCase();
    return v.indexOf('@') > 0 && v.indexOf('.', v.indexOf('@')) > 0 ? v : '';
  }

  function currentEmail() {
    var form = getForm();
    var live = form && form.querySelector('input[type="email"], input[name*="email" i]');
    return validEmail(live && live.value) || rememberedEmail;
  }

  function onAttempt() {
    var form = getForm();
    if (form) fillHiddenUtms(form);
    var email = currentEmail();
    if (email) send(email);
  }

  // Remember the email the moment it is typed (survives Helium removing the step).
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!isEmailInput(t)) return;
    var form = getForm();
    if (!form || !form.contains(t)) return;
    var v = validEmail(t.value);
    if (v) rememberedEmail = v;
  }, true);

  // Blur of a valid email = the lead is identified; stamp immediately.
  document.addEventListener('blur', function (e) {
    var t = e.target;
    if (!isEmailInput(t)) return;
    var form = getForm();
    if (!form || !form.contains(t)) return;
    var v = validEmail(t.value);
    if (v) { rememberedEmail = v; send(v); }
  }, true);

  // Defensive triggers: any form button click or a native submit.
  document.addEventListener('click', function (e) {
    var t = e.target;
    while (t && t.nodeType === 1) {
      if (t.tagName === 'BUTTON' || (t.tagName === 'INPUT' && t.type === 'submit')) {
        var f = t.form || (t.closest && t.closest('form[data-cf-form]'));
        if (f && f.getAttribute && f.getAttribute('data-cf-form') !== null) onAttempt();
        return;
      }
      t = t.parentNode;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('data-cf-form') !== null) onAttempt();
  }, true);

  // QC handle for verification scripts (harmless in production).
  window.__msWholesaleLead = { props: buildProps, attempt: onAttempt, sent: function () { return sentFor; }, email: currentEmail };
})();

/* Meta Lead ping (module 3). Meta's wholesale campaign optimizes on the custom
   conversion "Wholesale Registration Complete" = a browser Lead event fired on a
   wholesale URL. Nothing on the site fired ANY signup event before this module,
   so Meta had no signal to train on.

   QUALIFIED ONLY (owner's rule, 2026-08-17): the ping fires only when the lead
   picked a real business type. "Personal Use" alone never fires, so hobbyists
   never train the ads. The business checkboxes live on one step of the multi step
   Helium form and can leave the DOM later (like the email field), so choices are
   remembered on change, document level, same pattern as rememberedEmail above.

   Pixel note: this page has NO fbq global (Shopify's Facebook channel runs in its
   own sandbox and cannot fire custom events here). The standard loader is used
   with init only and NO PageView track, so retail pixel counts are untouched;
   the ONLY event this module can ever emit is Lead, once per session.
   Fire and forget: never blocks, delays, or alters the signup itself. */
(function () {
  if (window.location.pathname.indexOf('wholesale-registration') === -1) return;

  var PIXEL_ID = '1123522065545694';
  var PINGED = 'ms_wholesale_lead_pinged';
  var BUSINESS_FIELD = 'what_kind_of_business_are_';
  var rememberedBusiness = {};

  function loadPixel() {
    /* Standard Meta loader, minus the PageView call. */
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
  }
  loadPixel();

  function alreadyPinged() {
    try { return sessionStorage.getItem(PINGED) === '1'; } catch (e) { return false; }
  }

  function businessChoices() {
    /* Live DOM wins; remembered choices cover steps Helium has removed. */
    var boxes = document.querySelectorAll('input[name="' + BUSINESS_FIELD + '"]');
    for (var i = 0; i < boxes.length; i++) rememberedBusiness[boxes[i].value] = boxes[i].checked;
    return Object.keys(rememberedBusiness).filter(function (v) { return rememberedBusiness[v]; });
  }

  function isQualified() {
    return businessChoices().some(function (v) { return v !== 'Personal Use'; });
  }

  function maybeFireLead() {
    if (alreadyPinged()) return;
    if (!isQualified()) return;
    var lead = window.__msWholesaleLead;
    if (!lead || !lead.email()) return;
    try {
      window.fbq('track', 'Lead');
      try { sessionStorage.setItem(PINGED, '1'); } catch (e) {}
    } catch (e) {}
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === BUSINESS_FIELD) rememberedBusiness[t.value] = t.checked;
  }, true);

  /* Same defensive triggers as module 2: email blur, form button click, submit. */
  document.addEventListener('blur', function (e) { setTimeout(maybeFireLead, 0); }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    while (t && t.nodeType === 1) {
      if (t.tagName === 'BUTTON' || (t.tagName === 'INPUT' && t.type === 'submit')) {
        var f = t.form || (t.closest && t.closest('form[data-cf-form]'));
        if (f && f.getAttribute && f.getAttribute('data-cf-form') !== null) setTimeout(maybeFireLead, 0);
        return;
      }
      t = t.parentNode;
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('data-cf-form') !== null) setTimeout(maybeFireLead, 0);
  }, true);

  // QC handle for verification scripts (harmless in production).
  window.__msMetaLeadPing = { qualified: isQualified, choices: businessChoices, pinged: alreadyPinged, fire: maybeFireLead };
})();
